import {
    COMPETITION_NUMBERS_FAILURE,
    COMPETITION_NUMBERS_REQUEST,
    COMPETITION_NUMBERS_SUCCESS,
    ASSIGN_NUMBERS_SUCCESS,
} from 'actions';

const initialState = {
    // competitionId → CompetitionSportsman[]
    dataByCompetition: {},
    isFetched: [],
    isFetching: [],
    // Competitions whose last fetch failed — not retried automatically by
    // useCompetitionNumbers, or a persistent error re-fires the request in a
    // loop (same trap as the attendance slice).
    isFailed: [],
};

/**
 * Athlete numbers, one slice for the whole app.
 *
 * Every consumer — the draw, the brackets, the roster, applications, the
 * final result — reads the same map, so a number shown in one place can
 * never disagree with the same number elsewhere.
 *
 * Assigning numbers marks the competition stale rather than merging a
 * response: the assignment returns a summary, not the rows, and re-fetching
 * is both simpler and impossible to get subtly wrong.
 */
export const competitionSportsmanNumberListReducer = (state = initialState, action) => {
    const { type, data, competitionId } = action;
    switch (type) {
        case COMPETITION_NUMBERS_REQUEST:
            return {
                ...state,
                isFetching: [...state.isFetching.filter(id => id !== competitionId), competitionId],
            };

        case COMPETITION_NUMBERS_SUCCESS:
            return {
                ...state,
                isFetched: [...state.isFetched.filter(id => id !== competitionId), competitionId],
                isFetching: state.isFetching.filter(id => id !== competitionId),
                isFailed: (state.isFailed || []).filter(id => id !== competitionId),
                dataByCompetition: {
                    ...state.dataByCompetition,
                    [competitionId]: data,
                },
            };

        case COMPETITION_NUMBERS_FAILURE:
            return {
                ...state,
                isFetching: state.isFetching.filter(id => id !== competitionId),
                isFailed: [...(state.isFailed || []).filter(id => id !== competitionId), competitionId],
            };

        // Newly issued numbers are not in the response; drop the cache so the
        // next consumer re-fetches and everyone sees the same list.
        case ASSIGN_NUMBERS_SUCCESS:
            return { ...state, isFetched: [], isFetching: [], isFailed: [] };

        default:
            return state;
    }
};
